import * as React from 'react';

export interface CourseMediaAssets {
  posterPlaceholder?: string;
  audioCover?: string;
  emptyModule?: string;
}

export const CourseMediaAssetsContext = React.createContext<CourseMediaAssets>({});
